const SECTIONS = {
  JOBS: "jobs",
  NOTES: "notes",
  SUBMISSIONS: "submissions",
  SUBMISSION_HISTORY: "submissionHistory",
  CONTRACTS: "contracts"
};

const SECTIONS_TITLES = {
  jobs: "Jobs",
  notes: "Notes",
  submissions: "Submissions",
  submissionHistory: "Sub History",
  contracts: "Contracts"
};

export { SECTIONS, SECTIONS_TITLES };
